import { Divider, Fab } from "@mui/material";
import React from "react";
import { useProductContext } from "../context";
import AddIcon from "@mui/icons-material/Add";
import { ToolbarThinWrapper } from "components/Toolbar/ToolbarThinWrapper";
import { FlexBox } from "components/Wrappers/FlexBox/FlexBox";
import { routeLinks } from "constants/paths";
import KeyboardDoubleArrowLeftIcon from "@mui/icons-material/KeyboardDoubleArrowLeft";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

export const ProductTopBanner = ({ buttonType }) => {
  const { currentProject, bdc } = useProductContext();
  const currentUserId = useSelector((state) => state.user.state.userId);
  const navigate = useNavigate();
  return (
    <>
      <FlexBox flex={1} justifyContent="end">
        {buttonType === "back" ? (
          <></>
        ) : (
          bdc === currentUserId && (
            <Fab
              color="primary"
              size="small"
              aria-label="Add"
              onClick={() => {
                navigate(
                  routeLinks.projectManagementProduct +
                    "/" +
                    currentProject +
                    "/add"
                );
              }}
            >
              <AddIcon />
            </Fab>
          )
        )}
        <Divider orientation="vertical" flexItem />
        <Fab
          color="primary"
          size="small"
          aria-label="Back"
          onClick={() => {
            navigate(routeLinks.projectManagementProject);
          }}
        >
          <KeyboardDoubleArrowLeftIcon />
        </Fab>
      </FlexBox>
      <ToolbarThinWrapper />
    </>
  );
};
